<template>
  <div>
    <nav>

      <div class="brand" @click='toggleMenu'>
        <i class="fa fa-fw" aria-hidden="true" :class="menuIcon" v-if="!bare"></i>
        <img src="/static/img/folyo_logo_w.svg" class='logo' alt="Folyo">
      </div>

      <div class="user" @click="userToggle = true" @mouseover="userToggle = true" v-if="!bare">
        <i class="fa fa-fw fa-user" aria-hidden="true"></i>
        <span class="hidden-xs">{{ user.email }}</span>
        <i class="fa fa-fw fa-caret-down" aria-hidden="true"></i>
      </div>

    </nav>

    <div class="user-expanded" v-if='userToggle' @click="userToggle = false"  @mouseleave="userToggle = false">

      <router-link
        :to="{ name: 'User'}"
        tag="a"
        class="item"
        v-t="'topnav.settings'"/>

      <router-link
        :to="{ name: 'Login'}"
        tag="a"
        class="item"
        v-t="'topnav.logout'"/>

    </div>

  </div>
</template>

<script>
import {
  mapState,
  mapMutations
} from 'vuex'

export default {
  name: 'Navbar',
  props: ['bare'],
  data () {
    return {
      userToggle: false
    }
  },
  computed: {
    ...mapState(['env', 'user']),
    menuIcon () {
      var self = this
      return self.env.menu ? 'fa-bars' : 'fa-chevron-right'
    }
  },
  methods: {
    ...mapMutations(['toggleMenu'])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" src="../../styles/_Navbar.styl"/>



// WEBPACK FOOTER //
// src/components/common/Navbar.vue